import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin: 0 auto;
  max-width: ${props => props.small ? '940px' : '1440px'};
  padding: 0 15px;
`